import { GsFormSchema } from 'libs/shared/src/components/gs-form/interfaces/gs-form-schema';
import { DEFAULT_CONFIG } from 'libs/shared/src/services/config/default.config';
import { HORIZONTAL_ALIGNMENT_SCHEMA } from './alignment.schema';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { buttonSchemaFields } from './../basics/button-fields.schema';
import { SPACING_SCHEMA } from './spacing.schema';

/**
 * The schema for the registration confirm component form.
 * Defines the fields to display for the form.
 */
export const REGISTRATION_CONFIRM_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...BASIC_SCHEMA_FIELDS,
    ...HORIZONTAL_ALIGNMENT_SCHEMA,
    ...SPACING_SCHEMA,
    {
      formControlName: 'buttons',
      label: 'components.registrationConfirm.schema.buttons',
      type: 'group',
      expandable: true,
      default: DEFAULT_CONFIG.uiElements?.buttons ?? {},
      fields: buttonSchemaFields()
    }
  ]
};
